<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Create Branch Office of Research Center</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>

          <div class="card-collapse">Collapse</div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Institution *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="abbreviation" class="col-md-2">Subdomain *</label>
                  <div class="col-md-10">
                    <input
                      id="abbreviation"
                      v-model="entity.domain"
                      type="text"
                      placeholder="Enter abbreviation"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="localname" class="col-md-2">Institution Local Name</label>
                  <div class="col-md-10">
                    <input
                      id="localname"
                      v-model="entity.local_institution"
                      type="text"
                      placeholder="Enter Institution Local Name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Type</label>
                  <div class="col-md-10">
                    <select v-model="entity.type" class="form-control">
                      <option v-for="(value, key) in typeOptions" :key="value" :value="key">
                        {{ value }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="library" class="col-md-2">Organisation Library</label>
                  <div class="col-md-10">
                    <input
                      id="library"
                      v-model="entity.library"
                      type="text"
                      placeholder="Enter Organisation Library"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>Address</strong>

          <div class="card-collapse">Collapse</div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="country" class="col-md-2">Country</label>
                  <div class="col-md-10">
                    <input
                      id="country"
                      v-model="entity.address.country"
                      type="text"
                      placeholder="Enter Country"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="state" class="col-md-2">State</label>
                  <div class="col-md-10">
                    <input
                      id="state"
                      v-model="entity.address.state"
                      type="text"
                      placeholder="Enter State"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="city" class="col-md-2">City</label>
                  <div class="col-md-10">
                    <input
                      id="city"
                      v-model="entity.address.city"
                      type="text"
                      placeholder="Enter City"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="zip" class="col-md-2">Zip code</label>
                  <div class="col-md-10">
                    <input
                      id="zip"
                      v-model="entity.address.zip"
                      type="text"
                      placeholder="Enter Zip code"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="streetAddress1" class="col-md-2">Street Address 1</label>
                  <div class="col-md-10">
                    <input
                      id="streetAddress1"
                      v-model="entity.address.street1"
                      type="text"
                      placeholder="Enter Street Address"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="streetAddress2" class="col-md-2">Street Address 2</label>
                  <div class="col-md-10">
                    <input
                      id="streetAddress2"
                      v-model="entity.address.street2"
                      type="text"
                      placeholder="Enter Street Address"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>Mail Address</strong>

          <div class="card-collapse">Collapse</div>
        </div>
        <div class="card-body form-horizontal collapse">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="mailCountry" class="col-md-2">Country</label>
                  <div class="col-md-10">
                    <input
                      id="mailCountry"
                      v-model="entity.mail_address.country"
                      type="text"
                      placeholder="Enter Country"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="mailState" class="col-md-2">State</label>
                  <div class="col-md-10">
                    <input
                      id="mailState"
                      v-model="entity.mail_address.state"
                      type="text"
                      placeholder="Enter State"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="mailCity" class="col-md-2">City</label>
                  <div class="col-md-10">
                    <input
                      id="mailCity"
                      v-model="entity.mail_address.city"
                      type="text"
                      placeholder="Enter City"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="mailZip" class="col-md-2">Zip code</label>
                  <div class="col-md-10">
                    <input
                      id="mailZip"
                      v-model="entity.mail_address.zip"
                      type="text"
                      placeholder="Enter Zip code"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="mailStreetAddress1" class="col-md-2">Street Address 1</label>
                  <div class="col-md-10">
                    <input
                      id="mailStreetAddress1"
                      v-model="entity.mail_address.street1"
                      type="text"
                      placeholder="Enter Street Address"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="mailStreetAddress2" class="col-md-2">Street Address 2</label>
                  <div class="col-md-10">
                    <input
                      id="mailStreetAddress2"
                      v-model="entity.mail_address.street2"
                      type="text"
                      placeholder="Enter Street Address"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>Alternative Address</strong>

          <div class="card-collapse">Collapse</div>
        </div>
        <div class="card-body form-horizontal collapse">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="altCountry" class="col-md-2">Country</label>
                  <div class="col-md-10">
                    <input
                      id="altCountry"
                      v-model="entity.alt_address.country"
                      type="text"
                      placeholder="Enter Country"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="altState" class="col-md-2">State</label>
                  <div class="col-md-10">
                    <input
                      id="altState"
                      v-model="entity.alt_address.state"
                      type="text"
                      placeholder="Enter State"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="altCity" class="col-md-2">City</label>
                  <div class="col-md-10">
                    <input
                      id="altCity"
                      v-model="entity.alt_address.city"
                      type="text"
                      placeholder="Enter City"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="altZip" class="col-md-2">Zip code</label>
                  <div class="col-md-10">
                    <input
                      id="altZip"
                      v-model="entity.alt_address.zip"
                      type="text"
                      placeholder="Enter Zip code"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="altStreetAddress1" class="col-md-2">Street Address 1</label>
                  <div class="col-md-10">
                    <input
                      id="altStreetAddress1"
                      v-model="entity.alt_address.street1"
                      type="text"
                      placeholder="Enter Street Address"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="altStreetAddress2" class="col-md-2">Street Address 2</label>
                  <div class="col-md-10">
                    <input
                      id="mailStreetAddress2"
                      v-model="entity.alt_address.street2"
                      type="text"
                      placeholder="Enter Street Address"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>Contact info</strong>

          <div class="card-collapse">Collapse</div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="director" class="col-md-2">Director</label>
                  <div class="col-md-10">
                    <input
                      id="director"
                      v-model="entity.contacts.director_name"
                      type="text"
                      placeholder="Enter Director Name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="phone" class="col-md-2">Phone</label>
                  <div class="col-md-5">
                    <input
                      id="phone"
                      v-model="entity.contacts.phone1"
                      type="text"
                      placeholder="Enter Phone"
                      class="form-control"
                    >
                  </div>
                  <div class="col-md-5">
                    <input
                      id="phone2"
                      v-model="entity.contacts.phone2"
                      type="text"
                      placeholder="Enter Phone 2"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="fax" class="col-md-2">Fax</label>
                  <div class="col-md-5">
                    <input
                      id="fax"
                      v-model="entity.contacts.fax1"
                      type="text"
                      placeholder="Enter Fax"
                      class="form-control"
                    >
                  </div>
                  <div class="col-md-5">
                    <input
                      id="fax2"
                      v-model="entity.contacts.fax2"
                      type="text"
                      placeholder="Enter Fax 2"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="officeEmail" class="col-md-2">Email</label>
                  <div class="col-md-5">
                    <input
                      id="officeEmail"
                      v-model="entity.contacts.email1"
                      type="text"
                      placeholder="Enter Email"
                      class="form-control"
                    >
                  </div>
                  <div class="col-md-5">
                    <input
                      id="officeEmail2"
                      v-model="entity.contacts.email2"
                      type="text"
                      placeholder="Enter Email 2"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="website" class="col-md-2">Website</label>
                  <div class="col-md-10">
                    <input
                      id="website"
                      v-model="entity.contacts.website"
                      type="text"
                      placeholder="Enter Website"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="directorEmail" class="col-md-2">Director Email</label>
                  <div class="col-md-10">
                    <input
                      id="directorEmail"
                      v-model="entity.contacts.director_email"
                      type="text"
                      placeholder="Enter Director Email"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>Location</strong>

          <div class="card-collapse">Collapse</div>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="googleLink" class="col-md-2">Google Maps link</label>
                  <div class="col-md-10">
                    <input
                      id="googleLink"
                      v-model="entity.location.gmap_link"
                      type="text"
                      placeholder="Enter Google Maps link"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Geocode</label>
                  <div class="col-md-5" style="margin-bottom: 1rem;">
                    <input
                      v-model="entity.location.lat"
                      type="text"
                      placeholder="Enter latitude"
                      class="form-control"
                    >
                  </div>
                  <div class="col-md-5">
                    <input
                      v-model="entity.location.lng"
                      type="text"
                      placeholder="Enter longitude"
                      class="form-control"
                    >
                  </div>
                  <div class="col-md-10 offset-md-2">
                    <gmap-map
                      v-if="entity.location"
                      style="width: 100%; height:350px; margin-top: 20px;"
                      :center="mapCenter"
                      :zoom="mapZoom"
                      @click="mapClick"
                    >
                      <gmap-marker
                        v-if="entity.location.lat && entity.location.lng"
                        :position="entityMapCenter"
                      />
                    </gmap-map>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Office has created successful!
          </div>

          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';

export default {
  name: 'BranchOfficesNew',

  mixins: [CreatePageMixin],

  data() {
    return {
      entity: {
        title: '',
        domain: '',
        local_institution: '',
        type: 'branch_office',
        library: '',
        address: {
          country: '',
          state: '',
          city: '',
          zip: '',
          street1: '',
          street2: '',
        },
        mail_address: {
          country: '',
          state: '',
          city: '',
          zip: '',
          street1: '',
          street2: '',
        },
        alt_address: {
          country: '',
          state: '',
          city: '',
          zip: '',
          street1: '',
          street2: '',
        },
        contacts: {
          director_name: '',
          director_email: '',
          phone1: '',
          phone2: '',
          fax1: '',
          fax2: '',
          email1: '',
          email2: '',
          website: '',
        },
        location: {
          gmap_link: '',
          lat: null,
          lng: null,
        },
      },
      mapCenter: {
        lat: 0,
        lng: 0,
      },
      mapZoom: 2,
      typeOptions: {
        main_office: 'Main Office',
        branch_office: 'Branch Office',
        research_center: 'Research Center',
      },
    };
  },

  computed: {
    entityMapCenter() {
      if (this.entity.location === undefined
          || this.entity.location.lat == null
          || this.entity.location.lng == null
      ) {
        return {
          lat: 0,
          lng: 0,
        };
      }
      return {
        lat: _.toNumber(this.entity.location.lat),
        lng: _.toNumber(this.entity.location.lng),
      };
    },
  },

  mounted() {
    $('.card-collapse').click(function () {
      const $body = $(this).parents('.card').children('.card-body');
      if ($body.hasClass('collapse')) {
        $body.slideDown(function () {
          $(this).removeClass('collapse');
        });
      } else {
        $body.slideUp(function () {
          $(this).addClass('collapse');
        });
      }
    });
  },

  destroyed() {
    $('.card-collapse').off('click');
  },

  methods: {
    mapClick(event) {
      this.entity.location.lat = event.latLng.lat();
      this.entity.location.lng = event.latLng.lng();
    },
    isEntityValid() {
      function validateEmail(email) {
        // eslint-disable-next-line
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (!this.entity.domain) {
        this.$_showError('Abbreviation of Title must be valid');
        return false;
      }
      if (this.entity.contacts.director_email
          && !validateEmail(this.entity.contacts.director_email)
      ) {
        this.$_showError('Office Email must be valid');
        return false;
      }
      return true;
    },
    saveRequest() {
      const postFormData = new FormData();
      const faxes = [];
      const phones = [];
      const emails = [];
      postFormData.append('title', this.entity.title);
      postFormData.append('domain', this.entity.domain);
      postFormData.append('type', this.entity.type);
      if (this.entity.local_institution) postFormData.append('local_institution', this.entity.local_institution);
      if (this.entity.library) postFormData.append('library', this.entity.library);
      postFormData.append('address', JSON.stringify(this.entity.address));
      postFormData.append('mail_address', JSON.stringify(this.entity.mail_address));
      postFormData.append('alt_address', JSON.stringify(this.entity.alt_address));
      if (this.entity.contacts.phone1) phones.push(this.entity.contacts.phone1);
      if (this.entity.contacts.phone2) phones.push(this.entity.contacts.phone2);
      if (this.entity.contacts.fax1) faxes.push(this.entity.contacts.fax1);
      if (this.entity.contacts.fax2) faxes.push(this.entity.contacts.fax2);
      if (this.entity.contacts.email1) emails.push(this.entity.contacts.email1);
      if (this.entity.contacts.email2) emails.push(this.entity.contacts.email2);
      postFormData.append('contacts', JSON.stringify({
        director_name: this.entity.contacts.director_name,
        director_email: this.entity.contacts.director_email,
        phone: phones,
        fax: faxes,
        email: emails,
        website: this.entity.contacts.website,
      }));
      postFormData.append('location', JSON.stringify(this.entity.location));

      return this.$apiHttp.post(`${this.$config.app_api.prefix}branch-offices`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/branch-offices/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in create office query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?822611da